module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-manage"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    staticClass: "search-form",
    attrs: {
      "inline": true,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.userId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "userId", $$v)
      },
      expression: "queryForm.userId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.competitionId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "competitionId", $$v)
      },
      expression: "queryForm.competitionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "nickname", $$v)
      },
      expression: "queryForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.matchName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "matchName", $$v)
      },
      expression: "queryForm.matchName"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'prize') ? _c('el-form-item', {
    attrs: {
      "label": "奖品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入奖品名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "prizeName", $$v)
      },
      expression: "queryForm.prizeName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'prize') ? _c('el-form-item', {
    attrs: {
      "label": "物流状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择物流状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.logisticsStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "logisticsStatus", $$v)
      },
      expression: "queryForm.logisticsStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未发货",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发货",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已签收",
      "value": 2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.resetQuery
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "prize"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("奖品记录")]), _vm._v(" "), _c('div', {
    staticClass: "tab-header"
  }, [_c('span', {
    staticClass: "prize-tip"
  }, [_vm._v("仅展示【已完赛】用户的奖品发放/领取情况")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openImportLogisticsDialog
    }
  }, [_vm._v("批量填写物流")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.prizeLoading),
      expression: "prizeLoading"
    }],
    ref: "prizeTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.prizeData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "65",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeRecordId",
      "label": "奖品唯一ID",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "用户ID",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userNickname",
      "label": "昵称",
      "align": "center",
      "width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "competitionTitle",
      "label": "赛事标题",
      "align": "center",
      "min-width": "150",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupLabel",
      "label": "组别",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificateName",
      "label": "证书姓名",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registrationTime",
      "label": "报名时间",
      "align": "center",
      "width": "175",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.registrationTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packageName",
      "label": "套餐名称",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "套餐价格",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatPackagePrice(row.packagePrice)) + "元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "具体奖品名称",
      "align": "center",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiverName",
      "label": "姓名",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiverPhone",
      "label": "手机号",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullAddress",
      "label": "收货地址",
      "align": "center",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品领取",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.isClaimed === 1 ? "已领取" : "未领取"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流状态",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.type === 5 ? _vm.logisticsStatusText(row.logisticsStatus) : "--"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logisticsCompany",
      "label": "物流公司",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "物流单号",
      "align": "center",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryDeadline",
      "label": "发货截止时间",
      "align": "center",
      "width": "175",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.deliveryDeadline)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationTime",
      "label": "操作时间",
      "align": "center",
      "width": "175",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.operationTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.type === 5) ? [(row.completionStatus === 1 && row.logisticsStatus === 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openLogisticsDialog(row, false)
            }
          }
        }, [_vm._v("填写物流")]) : (row.logisticsStatus === 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openLogisticsDialog(row, true)
            }
          }
        }, [_vm._v("修改物流")]) : _c('span', [_vm._v("-")])] : _c('span', [_vm._v("--")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "signup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("报名记录")]), _vm._v(" "), _c('div', {
    staticClass: "signup-subtabs-bar"
  }, [_c('el-tabs', {
    staticClass: "signup-subtabs",
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleSignUpSubTabChange
    },
    model: {
      value: (_vm.signUpSubTab),
      callback: function($$v) {
        _vm.signUpSubTab = $$v
      },
      expression: "signUpSubTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完赛",
      "name": "finished"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未完赛",
      "name": "unfinished"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "signup-export-btn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleSignUpExport
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.signUpLoading),
      expression: "signUpLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.signUpData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "用户ID",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userNickname",
      "label": "用户名称",
      "align": "center",
      "width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "competitionTitle",
      "label": "赛事标题",
      "align": "center",
      "min-width": "200",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupLabel",
      "label": "报名组别",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificateName",
      "label": "证书姓名",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报名时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.registrationTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packageName",
      "label": "套餐名称",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "套餐价格",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatPackagePrice(row.packagePrice)) + "元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完赛状态",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          style: ({
            color: row.completionStatus === 1 ? '#67c23a' : '#e6a23c',
          })
        }, [_vm._v("\n              " + _vm._s(row.completionStatus === 1 ? "已完赛" : "未完赛") + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完赛公里数",
      "prop": "completeDistance",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(+row.completeDistance) ? _c('span', [_vm._v(_vm._s(+row.completeDistance / 1000))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewMatchDetail(row)
            }
          }
        }, [_vm._v("查看赛事")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewPrizeRecord(row)
            }
          }
        }, [_vm._v("查看奖品")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.tableTotal
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isEditLogistics ? '修改物流' : '填写物流',
      "size": "small",
      "modal-append-to-body": false,
      "close-on-click-modal": true
    },
    model: {
      value: (_vm.logisticsDialogVisible),
      callback: function($$v) {
        _vm.logisticsDialogVisible = $$v
      },
      expression: "logisticsDialogVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.logisticsForm,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流公司"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入，非必填"
    },
    model: {
      value: (_vm.logisticsForm.company),
      callback: function($$v) {
        _vm.$set(_vm.logisticsForm, "company", $$v)
      },
      expression: "logisticsForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流单号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.logisticsForm.trackingNo),
      callback: function($$v) {
        _vm.$set(_vm.logisticsForm, "trackingNo", $$v)
      },
      expression: "logisticsForm.trackingNo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "logistics-tip"
  }, [_vm._v("\n      确定后，将通过APPpush/站内信通知用户奖品已发出\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.logisticsDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.logisticsSubmitting
    },
    on: {
      "click": _vm.confirmLogistics
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量填写物流",
      "size": "small",
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.importLogisticsDialogVisible),
      callback: function($$v) {
        _vm.importLogisticsDialogVisible = $$v
      },
      expression: "importLogisticsDialogVisible"
    }
  }, [(!_vm.importResult) ? _c('div', [_c('p', {
    staticClass: "logistics-tip",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v("\n        请上传包含物流信息的 Excel/CSV 文件\n      ")]), _vm._v(" "), _c('el-upload', {
    ref: "importUpload",
    attrs: {
      "action": "",
      "auto-upload": false,
      "limit": 1,
      "on-change": _vm.handleImportFileChange,
      "on-remove": _vm.handleImportFileRemove,
      "accept": ".xlsx,.xls,.csv"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('span', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(" 支持 xlsx / xls / csv 格式")])], 1)], 1) : _c('div', {
    staticClass: "import-result"
  }, [_c('p', [_c('span', {
    staticClass: "result-success"
  }, [_vm._v("成功：" + _vm._s(_vm.importResult.successCount) + " 条")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "result-skip"
  }, [_vm._v("跳过：" + _vm._s(_vm.importResult.skipCount) + " 条")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "result-fail"
  }, [_vm._v("失败：" + _vm._s(_vm.importResult.failCount) + " 条")])]), _vm._v(" "), (_vm.importResult.messages && _vm.importResult.messages.length) ? _c('div', [_c('p', {
    staticClass: "result-messages-title"
  }, [_vm._v("详情：")]), _vm._v(" "), _c('ul', {
    staticClass: "result-messages"
  }, _vm._l((_vm.importResult.messages), function(msg, idx) {
    return _c('li', {
      key: idx
    }, [_vm._v("\n            " + _vm._s(msg) + "\n          ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeImportDialog
    }
  }, [_vm._v(_vm._s(_vm.importResult ? "关闭" : "取消"))]), _vm._v(" "), (!_vm.importResult) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.confirmImportLogistics
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-header__title"
  }, [_vm._v("报名管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43c9e4c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/signUpManage.vue
// module id = 1004
// module chunks = 0